import httpRequest from '../utils/request';

export async function searchProducts(term){
  const t = String(term||'').trim();
  if(t.length < 2) return [];
  const resp = await httpRequest.get('/product/search', { params: { q: t } });
  return resp.data || [];
}

export async function listTopProducts(limit=10){
  try {
    const resp = await httpRequest.get('/product/all-products');
    const arr = resp.data || [];
    return arr.slice(0, limit);
  } catch(e){
    return [];
  }
}

// Buscar producto por código de barras exacto (usa search-by-barcode backend)
export async function searchProductByBarcode(code){
  const c = String(code||'').trim();
  if(!c) return null;
  try {
    const resp = await httpRequest.get('/product/search-by-barcode', { params: { code: c } });
    return resp.data || null;
  } catch(e){
    return null; // 404 => no encontrado
  }
}
